export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    // Decode JWT token (il token JWT ha 3 parti separate da '.')
    const parts = token.split('.');
    if (parts.length !== 3) return true;
    
    // Decodifica la parte payload (seconda parte)
    const payload = JSON.parse(atob(parts[1]));
    
    // Verifica se il token ha un campo exp (expiration)
    if (!payload.exp) return false; // Se non ha scadenza, consideralo valido
    
    // Confronta con il timestamp corrente (in secondi)
    const currentTime = Date.now() / 1000;
    
    // Aggiungi un buffer di 60 secondi per evitare problemi di sincronizzazione
    return payload.exp < currentTime - 60;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true; // In caso di errore, considera il token come scaduto
  }
};

export const getTokenExpiration = (token) => {
  if (!token) return null;
  
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    const payload = JSON.parse(atob(parts[1]));
    
    if (!payload.exp) return null;
    
    return new Date(payload.exp * 1000);
  } catch (error) {
    console.error('Error getting token expiration:', error);
    return null;
  }
};

export const decodeToken = (token) => {
  if (!token) return null;

  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    return JSON.parse(atob(parts[1]));
  } catch (error) {
    console.error('Error decoding token payload:', error);
    return null;
  }
};
